module.exports = __webpack_public_path__ + "static/rules_for_comprehensive_banking_services_for_individuals-396c1feb269a0b844f06f24d8302cb81.pdf";